import { c as _c } from "react/compiler-runtime";
import { useLanguage } from "@hooks/use-language";
import { AccountSettingsDropdown } from "@pages/account-settings/account-settings-dropdown";

/**
 * A simple Language dropdown.
 * When opened the user can chose between the available languages
 * and select to which one the Dashboard should be translated to.
 */
export function AccountLanguageSelector() {
  const $ = _c(11);
  const {
    supportedLanguages,
    updateLanguage,
    currentLanguage
  } = useLanguage();
  let t0;
  if ($[0] !== supportedLanguages) {
    t0 = supportedLanguages.map(_temp).sort(_temp2);
    $[0] = supportedLanguages;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const languageItems = t0;
  let t1;
  if ($[2] !== currentLanguage.code || $[3] !== currentLanguage.name) {
    t1 = {
      label: currentLanguage.name,
      value: currentLanguage.code
    };
    $[2] = currentLanguage.code;
    $[3] = currentLanguage.name;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== updateLanguage) {
    t2 = code => updateLanguage("account settings", code);
    $[5] = updateLanguage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== languageItems || $[8] !== t1 || $[9] !== t2) {
    t3 = <AccountSettingsDropdown items={languageItems} selectedItem={t1} onClickHandler={t2} />;
    $[7] = languageItems;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp2(a, b) {
  return a.value.localeCompare(b.value);
}
function _temp(language) {
  return {
    value: language.code,
    label: language.name
  };
}